export { default as emailFormat } from './emailFormat'
export { default as passwordFormat } from './passwordFormat'
export { default as required } from './required'

export async function validate (fields) {
    return new Promise((resolve, reject) => {
        let noError = true
        const errorsInputs = {}
        const checks = Object.keys(fields).map(async (input) => {
            const field = fields[input]
            const errors = await Promise.all(
                field.validators.map(async (validator) => {
                    if (!validator.exec) {
                        throw new Error('Validator must implement exec() function')
                    }
                    if (await validator.exec(field.value)) {
                        noError = false
                        return validator.message || 'Validator Error'
                    }
                    return null
                }, [])
            )

            errorsInputs[input] = errors.filter((error) => !!error)
        })

        Promise.all(checks).then(() => (noError ? resolve() : reject(errorsInputs)))
    })
}
